export default __webpack_public_path__ + "static/media/contactus.353608cf.svg";